import { Common, color } from '@stockbit/ui';
import styled, { css } from 'styled-components';

const { Input, Flex, Button: ButtonAntd } = Common;

export const SearchInput = styled(Input)`
  flex: 1 0 0;
  align-self: stretch;
  border: none;
  padding: 0 16px 0 0;

  .ant-input-affix-wrapper {
    border-radius: 4px;
  }

  .ant-input {
    height: 20px;
    line-height: 20px;
    font-size: 13px;
  }

  .ant-input-prefix {
    margin-right: 8px;
    height: 20px;
    line-height: 20px;
  }
`;

export const SearchWrapper = styled.div`
  padding: 14px 8px;
`;

export const SearchContainer = styled.div`
  border: 1px solid ${color.downgray};
  border-radius: 4px;
  padding: 8px 0px 8px 16px;
`;

export const SearchInputDivider = styled.div`
  margin-top: 4px;
  border-bottom: 1px solid ${color.downgray};
  width: calc(100% - 16px);
`;

export const StockChipWrapper = styled.div`
  display: flex;
  border-radius: 20px;
  padding: 4px 3px 4px 5px;
  border: 1px solid ${color.downgray};
  flex: 0 0 auto;
  order: 0;
  margin-bottom: 10px;
  margin-right: 4px;
  align-items: center;

  .remove-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    margin-left: 6px;
    cursor: pointer;

    img {
      width: 6.6px;
      height: 6.6px;
    }
  }
`;

export const CompanySearchResultWrapper = styled.div`
  margin-bottom: 50px;
`;

export const SkeletonWrapper = styled.div`
  height: 318px;
`;

export const SkeletonItemWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
`;

export const SkeletonItemText = styled.div`
  width: 246px;
  height: 20px;
  border-radius: 4px;
  background-color: #F6F6F6;
`;

export const SkeletonItemCheckbox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;

  .checkbox {
    width: 15.417px;
    height: 15.417px;
    border-radius: 50%;
    background-color: #F6F6F6;
  }
`;

export const ImagePlaceholder = styled.span`
  background-color: #3A645C;
  border-radius: 50%;
  color: ${color.light};
  display: flex;
  min-height: 20px;
  min-width: 20px;

  > small {
    font-family: 'Proxima Nova', sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 19px;
    margin: auto;
    text-align: center;
  }
`;

interface CheckboxProps {
  isDisabled: boolean;
}

export const Checkbox = styled.div <CheckboxProps>`
  width: 20px;
  height: 20px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  .selected {
    width: 15px;
    height: 15px;
  }

  .add {
    width: 15.417px;
    height: 15.417px;
  }

  ${({ isDisabled }) => isDisabled && css`
    .add {
      cursor: not-allowed;
      pointer-events: all !important;
    }
  `}
`;

export const FormFooterWrapper = styled(Flex)`
  padding: 10px 8px;
  gap: 8px;
  border-top: 1px solid ${color.downgray};
  position: absolute;
  bottom: 0;
  width: 100%;
  background: ${color.light};
`;

export const Button = styled(ButtonAntd)`
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 4px;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  padding: 6px 0;
  cursor: pointer;

  ${({ type }) => type === 'primary' && css`
    :disabled {
      color: ${color.light};
      background: ${color.hummingBird} !important;
    }

    :hover:disabled {
      color: ${color.light};
    }
  `}
`;

export const SearchItemContainer = styled(Flex).attrs({
  px: '20px',
  py: '10px',
  align: 'center',
})`
  gap: 12px;
  cursor: ${({ isDisabled }) => isDisabled ? 'not-allowed' : 'pointer'};
  :hover {
    background: #F7F7F7;
  }
`;
